export default __webpack_public_path__ + "static/nego_img-188619770ed875f2c62293633994768d.png";